import React, { useState } from 'react';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import EducationDetail from './EducationDetail';
import FoodDetail from './FoodDetail';
import TechnologyDetail from './TechnologyDetail';
import './Programs.css';

const Programs = () => {
    useScrollAnimation();
    const [selectedProject, setSelectedProject] = useState(null);
    
    const projects = [
        {
            id: 'education',
            icon: 'fa-graduation-cap',
            title: 'கல்வி (Education)',
            description: 'Education is the strongest weapon against poverty, and every child deserves the chance to learn with dignity.',
            achievements: [
                '14 active branches in rural areas',
                '800+ students receiving free education',
                'Structured academic support & value-based learning'
            ]
        },
        {
            id: 'food',
            icon: 'fa-bowl-rice',
            title: 'அன்னதானம் (Annadhanam)',
            description: 'Serving food with love and dignity to elders and needy children who deserve care and respect.',
            achievements: [
                '300 elders receive daily lunch & dinner',
                '70 students receive daily dinner',
                'Continuous community-based meal support'
            ]
        },
        {
            id: 'technology',
            icon: 'fa-computer',
            title: 'Ai தொழில்நுட்பம் (AI Technology)',
            description: 'Digital knowledge opens doors to employment, confidence, and equal opportunity in a modern world.',
            achievements: [
                '700+ students trained',
                'MS Office skill development',
                'Improving employability for rural youth'
            ]
        }
        
    ];

    const handleProjectClick = (projectId) => {
        setSelectedProject(projectId);
        // Scroll to details section smoothly
        setTimeout(() => {
            document.getElementById('project-details')?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
    };

    const handleBackToProjects = () => {
        setSelectedProject(null);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="programs-page">
            <div className="container">
                <div className="section-header">
                    <span className="section-tag">What We Do</span>
                    <h1 className="section-title">Our Projects</h1>
                    <p className="section-description">Comprehensive initiatives addressing critical needs in communities</p>
                </div>

                <div className="programs-grid">
                    {projects.map((project, index) => (
                        <div 
                            key={index} 
                            className={`program-card-large scroll-animate ${selectedProject === project.id ? 'active' : ''}`}
                            onClick={() => handleProjectClick(project.id)}
                        >
                            <div className="program-icon-large">
                                <i className={`fas ${project.icon}`}></i>
                            </div>
                            <h2>{project.title}</h2>
                            <p className="program-description">{project.description}</p>
                            
                            <div className="program-achievements">
                                <h3>Key Achievements</h3>
                                <ul>
                                    {project.achievements.map((achievement, i) => (
                                        <li key={i}>
                                            <i className="fas fa-check-circle"></i>
                                            {achievement}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            
                            <div className="learn-more">
                                Learn More <i className="fas fa-arrow-right"></i>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Project Details Section */}
                {selectedProject && (
                    <div id="project-details" className="project-details-container">
                        <button onClick={handleBackToProjects} className="back-to-projects-btn">
                            <i className="fas fa-arrow-up"></i> Back to Projects Overview
                        </button>
                        
                        {selectedProject === 'education' && <EducationDetail />}
                        {selectedProject === 'food' && <FoodDetail />}
                        {selectedProject === 'technology' && <TechnologyDetail />}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Programs;
